if (!customElements.get('variant-select')) {
  customElements.define(
    'variant-select',
    class VariantSelect extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-variant-select-trigger]');
        this.list = this.querySelector('[data-variant-select-list]');
        this.current = this.querySelector('[data-variant-select-current]');
        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.trigger.addEventListener('click', () => this.toggle());
        this.list.addEventListener('change', (event) => this.renderCurrent(event.target));
        this.list.addEventListener('click', (event) => {
          if (event.target.closest('[data-variant-select-content]')) this.close(true);
        });
        this.addEventListener('keydown', (event) => this.onKeyDown(event));
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      toggle() {
        if (this.isOpen()) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.list.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
        const checked = this.list.querySelector('input:checked') || this.list.querySelector('input');
        checked?.focus({ preventScroll: true });
      }

      close(restoreFocus = false) {
        this.list.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyDown(event) {
        if (!this.isOpen()) return;
        if (event.key === 'Escape' || (event.key === 'Enter' && event.target.matches('input'))) {
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
        }
      }

      renderCurrent(input) {
        const content = this.list.querySelector(`label[for="${input.id}"]`);
        if (content) this.current.innerHTML = content.innerHTML;
      }
    }
  );
}
